import { Default, Detail,  List, Create } from "./views";


const Module = {
    name: "legalentities",
    defaultRoutePath: "/legalentities/legalentity",
    menuItemScope: "legalentities",
    menuItemName: "legalentities",

    routes: [
        {
            path: "/legalentities/legalentity",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        }
        
    ],
    
}

export default Module;
